const isMobile = () => typeof window !== 'undefined' && window.innerWidth <= 400;
const isDevelopment = () => /(localhost|127\.0\.0\.1)/.test(window.location.host);
const isTest = () => /nginx/.test(window.location.host);
export default {
  isMobile,
  isDevelopment,
  isTest,
};
